
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/schemas/bilanPatrimoineSchema";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown } from "lucide-react";

interface FinancialSituationSectionProps {
  form: UseFormReturn<FormValues>;
}

const FinancialSituationSection: React.FC<FinancialSituationSectionProps> = ({ form }) => {
  return (
    <>
      <h3 className="text-lg font-medium pt-4 border-t border-gray-200">Situation Financière</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="revenus"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Revenus annuels nets (€)</FormLabel>
              <FormControl>
                <Input type="number" placeholder="Montant" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="charges"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Charges annuelles (€)</FormLabel>
              <FormControl>
                <Input type="number" placeholder="Montant" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <Collapsible className="bg-gray-50 rounded-md p-4">
        <CollapsibleTrigger className="flex w-full items-center justify-between font-medium text-left">
          <span>Patrimoine Détaillé (optionnel)</span>
          <ChevronDown className="h-4 w-4 transition-transform duration-200 collapsible-open:rotate-180" />
        </CollapsibleTrigger>
        <CollapsibleContent className="pt-4 space-y-4">
          <FormField
            control={form.control}
            name="immobilier"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Patrimoine immobilier (€)</FormLabel>
                <FormControl>
                  <Input type="number" placeholder="Valeur estimée (optionnel)" {...field} />
                </FormControl>
                <FormDescription>Ce champ est optionnel</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="financier"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Patrimoine financier (€)</FormLabel>
                <FormControl>
                  <Input type="number" placeholder="Valeur estimée (optionnel)" {...field} />
                </FormControl>
                <FormDescription>Ce champ est optionnel</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        </CollapsibleContent>
      </Collapsible>
    </>
  );
};

export default FinancialSituationSection;
